// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3RNK7","inputWrap":"styles_inputWrap__3NM9D","input":"styles_input__2wNfP"};